var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25473 0.408412C1.73893 -0.136138 0.902651 -0.136137 0.38685 0.408413C-0.12895 0.952963 -0.12895 1.83585 0.38685 2.3804L4.74523 6.98171C5.26103 7.52626 6.09731 7.52626 6.61311 6.98171C7.12891 6.43716 7.12891 5.55427 6.61311 5.00972L2.25473 0.408412Z",
    fill: "#9E9288"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.386889 9.6196C-0.128911 10.1641 -0.128911 11.047 0.386889 11.5916C0.902689 12.1361 1.73897 12.1361 2.25477 11.5916L6.61315 6.99028C7.12895 6.44573 7.12895 5.56284 6.61315 5.01829C6.09735 4.47374 5.26107 4.47374 4.74527 5.01829L0.386889 9.6196Z",
    fill: "#9E9288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightSm);
export default __webpack_public_path__ + "static/media/chevron-right-sm.745e0c25a50baaa3fcb6b4bba300bbfe.svg";
export { ForwardRef as ReactComponent };